import { render, staticRenderFns } from "./Pengaduan.vue?vue&type=template&id=4d537efe"
import script from "./Pengaduan.vue?vue&type=script&lang=js"
export * from "./Pengaduan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports